import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { IPageParams } from '../api/IApi';
import { EMPTY_ORDER_SEARCH, IOrderFilterState } from '../api/orderFilter';
import { CONFIG } from '../config';
import { presetRange } from '../components/orders/orderDatePresets';

export interface IOrderSliceInitState {
  listPageParams: IPageParams;
  listFilter: IOrderFilterState;
}

// --
// -- Kept in the store rather than in component state so paging and the date
// -- range survive navigating to an order and back.
// --
const initialState: IOrderSliceInitState = {
  listPageParams: {
    page: 0,
    size: CONFIG.order.ordersPerPage,
    q: '',
    sort: 'timeCreate',
    sortDir: 'desc',
  },
  listFilter: {
    ...presetRange('today'),
    ...EMPTY_ORDER_SEARCH,
  },
};

const orderSlice = createSlice({
  name: 'orderSlice',
  initialState,

  reducers: {
    setOrderListPageParams: (state: IOrderSliceInitState, action: PayloadAction<IPageParams>) => {
      state.listPageParams = action.payload;
    },
    // -- Any filter change returns to the first page: page 4 of the old result
    // -- set means nothing once the range moves.
    setOrderListFilter: (state: IOrderSliceInitState, action: PayloadAction<IOrderFilterState>) => {
      state.listFilter = action.payload;
      state.listPageParams = { ...state.listPageParams, page: 0 };
    },
  },
});

export default orderSlice.reducer;
export const {
  setOrderListPageParams,
  setOrderListFilter,
} = orderSlice.actions;

export const getOrderListPageParams = () => (state: RootState) => state.orderSlice.listPageParams;
export const getOrderListFilter = () => (state: RootState) => state.orderSlice.listFilter;
